import { render } from "./Distribution.vue?vue&type=template&id=9defa3e6&ts=true"
import script from "./Distribution.vue?vue&type=script&lang=ts"
export * from "./Distribution.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__